import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import { SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { currentDateAndTime, decodeData } from "../../Constants/constants";
import { constructNow } from "date-fns";
import TooltipComponent from "../../Components/TooltipComponent";

class AssignLeaves extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      company_location_shift_id: 0,
      leave_type_ids: "",
      effective_date: null,
      location_shift_id: "",
      grade_id: "",
      designation_id: "",
      location_id: "",
      department_id: "",
      category_id: "",
      state_id:"",
      employee_type_id:"",
      assigned_leave_status:"All",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      assignLeaveModal: false,
      Shift_rows: [],
      leaves_options: [],
      location_options: [],
      department_options: [],
      designation_options: [],
      grade_options: [],
      state_options: [],
      category_options: [],
      type_options: [],
      location_row: [],
      company_location_shift_row: [],
      days_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      loadingFilter: false,
      loadingSearch: false,
      decodedData: [],
      assignedLeaveModal: false,
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetShiftList();
    //   this.GetLocationList();
    //   this.GetDepartmentMasters();
    this.GetLeavesMasters();
    this.GetEmploymentMasterList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("this.state.assigned_leave_status",this.state.assigned_leave_status);
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context; // Extract API URL and headers from context
    const headers = apiHeaderJSON; // Define headers
    
    // Axios GET request
    axios
      .get(`${apiURL}Employees/GetAssignLeaves`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          grade_id: this.state.grade_id || "",
          designation_id: this.state.designation_id || "",
          location_id: this.state.location_id || "",
          department_id: this.state.department_id || "",
          category_id: this.state.category_id || "",
          assigned_leave_status: this.state.assigned_leave_status==="All" ? null : this.state.assigned_leave_status,
        },
        headers,
      })
      .then((response) => {
        // Check if the API call was successful
        if (response.data.success === true) {
          const data = response.data;
          console.log("GetAssignLeaves data",data);
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
          });
        }
        this.setState({
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
      })
      .catch((error) => {
        // Handle API errors
        console.error("Error fetching data:", error);
        this.setState({
          loadingList: false,
          loadingSearch: false,
          loadingFilter: false,
        });
      });
  };
  
  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const formData = {
      employee_ids: this.state.selectedRows,
      leave_type_ids: this.state.leave_type_ids,
      date: currentDateAndTime(),
    };
    console.log("form data ====>>>", formData);
    axios
      .post(`${apiURL}Employees/AssignLeaves`, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          this.setState(
            {
              loadingList: true,
              selectedRows: [],
              assignLeaveModal:false,
              leave_type_ids: "",
              postLoading:false,
            },
            (prevState) => {
              this.GetList();
            //   this.GetLocationList();
            //   this.GetDepartmentMasters();
              this.GetShiftList();
              this.GetEmploymentMasterList();
            }
          );
        } else {
          this.setState({ loadingList: true, postLoading:false });
        }
        Swal.fire({
        title: `<strong>${
            response.data.success === true ? "Success" : "Failed"
        }</strong>`,
        text: response.data.message,
        icon: response.data.success === true ? "success" : "error",
        showConfirmButton: true,
        allowOutsideClick: false,
        });
      })
      .catch((error)=>{
        this.setState({ loadingList: true, postLoading:false });
        Swal.fire({
            title: `<strong>Failed}</strong>`,
            text: "Opps...! Something went wrong.",
            icon: "error",
            showConfirmButton: true,
            allowOutsideClick: false,
        });
      });
  };

  handleInputSearch = (e) => {
      this.GetList();
  };
  handleClearAll = () => {
    this.setState(
      {
        grade_id: "",
        designation_id: "",
        location_id: "",
        department_id: "",
        category_id: "",
        location_shift_id: "",
        assigned_leave_status: "All",
        keyword: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
      },
      () => {
        this.GetList();
      }
    );
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    },
    () => {
      if (this.state.keyword === "") {
        this.GetList();
      }
    });
  };

  handleMultiSelect = (fieldName, selectedOptions) => {
    if (selectedOptions.some(option => option.value === "All")) {
        // Get all options except "All"
        const ids = this.state.leaves_options
            ? this.state.leaves_options
                  .filter(option => option.value !== "All")
                  .map(option => option.value)
            : [];
        console.log(ids.join(','));
        this.setState({ [fieldName]: ids.join(',') },()=> console.log("leave_type_ids 1",this.state.leave_type_ids));
    } else {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({ [fieldName]: ids.join(',') },()=> console.log("leave_type_ids 2",this.state.leave_type_ids));
    }
};


  handleCheckboxChange = (row) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(row?.employee_id)) {
        selectedRows.splice(selectedRows.indexOf(row?.employee_id), 1);
      } else {
        selectedRows.push(row?.employee_id);
      }

      return { selectedRows };
    },()=>{
        if(this.state.selectedRows.length===1){
            this.setState({ leave_type_ids: row?.leave_type_ids})
        }
        else{
            this.state.leave_type_ids &&  this.setState({ leave_type_ids: ""})
        }
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows =
        prevState.selectedRows.length === prevState.rows.length
          ? []
          : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === "select-all") {
      this.setState({
        selectedRows: this.state.rows.map((row) => row.employee_id),
      });
    } else if (action === "deselect-all") {
      this.setState({ selectedRows: [] });
    }
  };

  GetShiftList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetShiftList `, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Shift_rows: data.data.map((row) => ({
              value: row.company_location_shift_id,
              label: row.company_location_shift_name,
            })),
          }));
        }
      });
  };

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.department;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          department_options: data.map((row) => ({
            value: row.department_id,
            label: row.department_title,
          })),
        }));
      }
    });
  };
  GetLeavesMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLeaveTypesSandbox`, 
        { params: { 
            limit: 999, 
            page: 1 
        }, headers })
    .then((response) => {
      const data = response.data.data;
      if (response.data.success === true) {
        console.log("GetLeaveTypesSandbox",data);
        const temp = data.map((row) => ({
            value: row.leave_type_id,
            label: row.leave_type_name,
          }));
        temp.unshift({value:'All', label:"All"});
        console.log("temp",temp);
        this.setState((prevState) => ({
          leaves_options: temp,
        }));
      }
    });
  };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            location_options: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetEmploymentMasterList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetEmploymentMasterList`, { headers })
      .then((response) => {
        let data = response.data;
        if (response.data.success === true) {
            data= data?.data;
          this.setState((prevState) => ({
            location_options: data.location_list.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
            department_options: data?.department_list.map((row) => ({
                value: row.department_id,
                label: row.department_title,
              })),
            designation_options: data?.designation_list.map((row) => ({
                value: row.designation_id,
                label: row.designation_title,
              })),
            grade_options: data?.grade_list.map((row) => ({
                value: row.grade_id,
                label: row.grade_title,
              })),
            state_options: data?.state_list.map((row) => ({
                value: row.state_id,
                label: row.state_title,
              })),
            category_options: data?.category_list.map((row) => ({
                value: row.company_employee_category_id,
                label: row.company_employee_category,
              })),
            type_options: data?.type_list.map((row) => ({
                value: row.company_employee_type_id,
                label: row.company_employee_type,
              })),
          }));  
        }
      });
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
        this.GetShiftList();
        this.GetLocationList();
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };


  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500, ];
    const assignedStatusOptions=[
        {value:"All", label:"All"},
        {value:"1", label:"Assigned"},
        {value:"2", label:"UnAssigned"},
        
    ];

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Assign Leaves`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="keyword">Employee Name/Code</label>
                        <div className="input-group">
                          <input
                            type="search"
                            className="form-control"
                            onChange={this.handleInputChange}
                            name="keyword"
                            value={this.state.keyword}
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder="Search Here..."
                          />
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingSearch}
                            onClick={() => {
                              if (
                                this.state.keyword &&
                                !this.state.loadingSearch
                              ) {
                                this.handleInputSearch();
                              }
                            }}
                            type="button"
                            id="button-addon2"
                          >
                            {this.state.loadingSearch ? (
                              <span
                                class="spinner-border flex-shrink-0"
                                role="status"
                                style={{
                                  width: "0.8rem",
                                  height: "0.8rem",
                                  borderWidth: "2px",
                                }}
                              >
                                <span class="visually-hidden">Loading...</span>
                              </span>
                            ) : (
                              <i className="ri-search-line"></i>
                            )}
                          </button>
                        </div>
                      </div>
                        <div className="col-md-3 position-relative">
                            <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Grade</label>
                                </div>
                                <Select
                                options={this.state.grade_options}
                                value={
                                    this.state.grade_id
                                    ? this.state.grade_options.find(
                                        (option) =>
                                            option.value === this.state.grade_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "grade_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Grade`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 position-relative">
                            <div style={{ zIndex: 9, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Designation</label>
                                </div>
                                <Select
                                options={this.state.designation_options}
                                value={
                                    this.state.designation_id
                                    ? this.state.designation_options.find(
                                        (option) =>
                                            option.value === this.state.designation_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "designation_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Designation`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 8, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Location</label>
                                </div>
                                <Select
                                options={this.state.location_options}
                                value={
                                    this.state.location_id
                                    ? this.state.location_options.find(
                                        (option) =>
                                            option.value === this.state.location_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "location_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Location`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 7, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Department</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "department_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Department`}
                                options={this.state.department_options}
                                value={
                                    this.state.department_id
                                    ? this.state.department_options.find(
                                        (option) =>
                                            option.value === this.state.department_id
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 6, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Category</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "category_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Category`}
                                options={this.state.category_options}
                                value={
                                    this.state.department_id
                                    ? this.state.category_options.find(
                                        (option) =>
                                            option.value === this.state.category_id
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 5, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Assigned Status</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "assigned_leave_status",
                                    selectedOption
                                    )
                                }
                                placeholder={`All`}
                                options={assignedStatusOptions}
                                value={
                                    this.state.assigned_leave_status
                                    ? assignedStatusOptions.find(
                                        (option) =>
                                            option.value === this.state.assigned_leave_status
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div>
                        <div className="col-md-3 ">
                            <div className="row">
                                <div className="col-md-6">
                                <div>
                                    <label>Apply Filter</label>
                                </div>
                                    <SubmitButton
                                    onClick={()=>{
                                        if(!this.state.loadingFilter){
                                            this.setState({loadingFilter: "1"},
                                            () => { this.handleInputSearch()})
                                        }
                                    }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_leave_status || this.state.assigned_leave_status==="All")}
                                    loading={this.state.loadingFilter==="1"}
                                    loadingMessage='loading' buttonName={"Filter"} icon={'ri-filter-3-fill'} 
                                    type='info' iconSide='left' />
                                </div>
                                <div className="col-md-6">
                                    <div>
                                        <label>Clear Filter</label>
                                    </div>
                                    <SubmitButton
                                        onClick={()=>{
                                    if(!this.state.loadingFilter){
                                        this.setState({loadingFilter: "2"},
                                        () => { this.handleClearAll()})
                                    }
                                    }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_leave_status || this.state.assigned_leave_status==="All")}
                                    loading={this.state.loadingFilter==="2"}
                                    loadingMessage='loading' buttonName={"Clear"} icon={'ri-database-2-line'} 
                                    type='secondary' iconSide='left' />
                                </div>
                            </div>
                        </div>
                    
                        { this.state.decodedData?.includes(3) && (
                        <div className='col-md-3 '>
                            <div>
                            <label>Assign Leaves</label>
                            </div>
                            <button
                            onClick={()=> this.setState({assignLeaveModal:true})}
                            type="button"
                            className={`btn btn-success btn-label waves-effect waves-light 
                            ${(this.state.selectedRows.length === 0) ? 'disabled' : ''}`}>
                            <i className="ri-user-settings-line label-icon align-middle fs-16" />
                            Assign
                            </button>
                        </div>)}
                    </div>
                  </div>
                  <div className="card-body">
                  <div className="row">
                    <div style={{ maxHeight: '65vh', overflowY: 'auto' }} className="col-sm-12">
                        <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative"
                            style={{ minWidth: '100%' }}>
                        <thead  className="bg-primary text-light bg-gradient  sticky-top z-1">
                            <tr>
                            {this.state.rows.length>0 && this.state.decodedData?.includes(3) && (
                            <th>
                                <div className="d-flex gap-1 align-items-center justify-content-center">
                                    <input type="checkbox" className="form-check-input cursorPointer" 
                                    checked={this.state.selectedRows.length === this.state.rows.length && this.state.rows.length>0}
                                    onChange={this.handleSelectAll}
                                    />
                                    Select{" "}
                                    {this.state.selectedRows?.length > 0 && ( <span className="text-white">({this.state.selectedRows?.length})
                                    </span>
                                    )}
                                </div>
                            </th>)}
                            <th>Employee Code</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            <th>Employee Email Address</th>
                            <th>Assigned Leaves</th>
                            </tr>
                        </thead>
                        {this.state.rows.length === 0 ? (
                            <tbody>
                            <tr>
                                <td colSpan={11}>
                                <NoRecords />
                                </td>
                            </tr>
                            </tbody>
                        ) : (
                            <tbody>
                            {this.state.rows.map((row) => {
                                return (
                                <tr key={row.employee_id}>
                                    { this.state.decodedData?.includes(3) && (
                                    <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={this.state.selectedRows.includes(
                                            row.employee_id
                                        )}
                                        onChange={() =>
                                            this.handleCheckboxChange(
                                            row
                                            )
                                        }
                                        />
                                    </div>
                                    </td>)}
                                    <td>{row.employee_code}</td>
                                    <td>{row.employee_name}</td>
                                    <td>{row.designation_title}</td>
                                    <td>{row.employee_email_address}</td>
                                    <td className=" text-center">
                                        {row.leave_type_names && row.leave_type_names?.length>0 ? (
                                        <div onClick={()=>{this.setState({ assignedLeaveModal: row?.leave_type_ids })}} className={`badge bg-success cursorPointer`}>
                                            View
                                        </div>
                                        ) : (
                                        <span className={`badge bg-info`}>
                                            UnAssign
                                        </span>
                                    )}
                                    </td>
                                </tr>
                                );
                            })}
                            </tbody>
                        )}
                        </table>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2">
                        <button
                        disabled={
                            this.state.prev === false &&
                            this.state.loadingList === false
                            ? true
                            : false
                        }
                        type="button"
                        onClick={() => this.handlePrev()}
                        className={`btn btn-warning btn-label waves-effect waves-light`}
                        >
                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                        Previous
                        </button>
                        <div
                        className="col-md-4"
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                        >
                        {
                            <small>
                            Total Records: {this.state.total_records} |
                            Total Pages: {this.state.total_pages} |
                            Current Page: {this.state.page}
                            </small>
                        }
                        </div>
                        <div className="col-md-2">
                        <select
                            className="form-select"
                            onChange={(e) => this.handleChange(e)}
                        >
                            {Array.from(
                            { length: this.state.total_pages },
                            (_, i) => (
                                <option
                                selected={this.state.page === i + 1}
                                key={i}
                                value={i + 1}
                                >
                                Page {i + 1}
                                </option>
                            )
                            )}
                        </select>
                        </div>
                        <div className="col-md-2">
                        <select
                            className="form-select"
                            onChange={this.handleLimitChange}
                            value={this.state.limit}
                        >
                            <option value={this.state.total_records}>
                                All
                            </option>
                            {limitOptions.map((option) => (
                                <option key={option} value={option}>
                                Limit {option}
                                </option>
                            ))}
                        </select>
                        </div>
                        <button
                        disabled={
                            this.state.next === false &&
                            this.state.loadingList === false
                            ? true
                            : false
                        }
                        type="button"
                        onClick={() => this.handleNext()}
                        className={`btn btn-primary btn-label waves-effect right waves-light`}
                        >
                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                        Next
                        </button>
                    </div>
                    </div>
                    {this.state.assignLeaveModal && (
                        <div className="modal show" tabIndex={-1}
                            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                            aria-labelledby="myModalLabel"
                            aria-hidden="true">
                        <div className=" bg-light m-auto mt-3"
                                style={{ width: "40%" }}>
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assign Leaves</h5>
                                <button
                                type="button"
                                disabled={this.state.postLoading}
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({assignLeaveModal:false, leave_type_ids:"", selectedRows:[]});
                                    }
                                }}
                                className="btn-close"
                                aria-label="Close"
                                />
                            </div>
                            <div className="modal-body py-0">
                                <form>
                                <div className="mb-3">
                                    <label>Select Leaves</label>
                                    <Select
                                    ref={this.sourceDiv1Ref}
                                    onChange={(selectedOptions) => this.handleMultiSelect("leave_type_ids", selectedOptions)}
                                    placeholder={"Select Leaves"}
                                    isMulti
                                    options={this.state.leaves_options}
                                    value={this.state.leave_type_ids ? this.state.leave_type_ids.split(',').map(id => this.state.leaves_options.find(option => option.value == id)) : null}
                                />
                                </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                type="button"
                                className="btn btn-light"
                                disabled={this.state.postLoading}
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({assignLeaveModal:false, leave_type_ids:""});
                                    }
                                }}
                                >
                                Close
                                </button>
                                {/* <button
                                type="button"
                                onClick={this.handleSubmit}
                                disabled={!this.state.leave_type_ids}
                                className="btn btn-success"
                                data-bs-dismiss="modal"
                                >
                                Assign
                                </button> */}
                                <SubmitButton
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({postLoading:true},()=>this.handleSubmit())
                                    }
                                }}
                                disabled={!this.state.leave_type_ids}
                                loading={this.state.postLoading}
                                loadingMessage='loading' buttonName={"Assign"} icon={'ri-save-line'} 
                                type='success' iconSide='left' />
                            </div>
                            </div>
                        </div>
                        </div>
                    )}
                    {this.state.assignedLeaveModal && (
                        <div className="modal show" tabIndex={-1}
                            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                            aria-labelledby="myModalLabel"
                            aria-hidden="true">
                        <div className=" bg-light rounded-3 m-auto mt-3"
                                style={{ width: "40%" }}>
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assigned Leaves</h5>
                                <button
                                type="button"
                                disabled={this.state.postLoading}
                                onClick={()=>{
                                    if(!this.state.postLoading){
                                        this.setState({assignedLeaveModal:false, selectedRows:[]});
                                    }
                                }}
                                className="btn-close"
                                aria-label="Close"
                                />
                            </div>
                            <div className="modal-body py-0">
                                <form>
                                <div className="mb-3">
                                    <label>Leaves</label>
                                    <Select
                                    ref={this.sourceDiv1Ref}
                                    // onChange={(selectedOptions) => this.handleMultiSelect("leave_type_ids", selectedOptions)}
                                    placeholder={"Select Leaves"}
                                    isMulti
                                    isDisabled
                                    options={this.state.leaves_options}
                                    value={this.state.assignedLeaveModal ? this.state.assignedLeaveModal.split(',').map(id => this.state.leaves_options.find(option => option.value == id)) : null}
                                />
                                </div>
                                </form>
                            </div>
                            </div>
                        </div>
                        </div>
                    )}
                
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    );
  }
}
export default withRouter(AssignLeaves);
